export default __webpack_public_path__ + "static/patient-education-desktop-509015479fe8b47f10ec6592e883d2b3.png";